// export const server = "http://103.189.80.206:8981/api/v1";
export const server = "https://doitserver.appdeploy.in/api/v1";
